__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "employee-app-fe";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http", "16.2.0", () => (__webpack_require__.e("node_modules_angular_common_fesm2022_http_mjs-_f9340").then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/common/fesm2022/http.mjs */ 54860))))));
			register("@angular/common", "16.2.0", () => (__webpack_require__.e("node_modules_angular_common_fesm2022_common_mjs-_b4621").then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/common/fesm2022/common.mjs */ 26575))))));
			register("@angular/core/rxjs-interop", "16.2.0", () => (__webpack_require__.e("node_modules_angular_core_fesm2022_rxjs-interop_mjs-_b06f1").then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/core/fesm2022/rxjs-interop.mjs */ 60839))))));
			register("@angular/core", "16.2.0", () => (__webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs").then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/core/fesm2022/core.mjs */ 7878))))));
			register("@angular/core", "16.2.0", () => (__webpack_require__.e("node_modules_ng-pick-datetime-moment_node_modules_angular_core_fesm2015_core_js-_d3e91").then(() => (() => (__webpack_require__(/*! ./node_modules/ng-pick-datetime-moment/node_modules/@angular/core/fesm2015/core.js */ 9994))))));
			register("@angular/router", "16.2.0", () => (__webpack_require__.e("node_modules_angular_router_fesm2022_router_mjs-_5a221").then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/router/fesm2022/router.mjs */ 27947))))));
			register("@ngxs/store/internals", "3.8.1-dev.master-43ab43c", () => (__webpack_require__.e("node_modules_ngxs_store_fesm2015_ngxs-store-internals_js-_68210").then(() => (() => (__webpack_require__(/*! ./node_modules/@ngxs/store/fesm2015/ngxs-store-internals.js */ 14101))))));
			register("@ngxs/store/operators", "3.8.1-dev.master-43ab43c", () => (__webpack_require__.e("node_modules_ngxs_store_fesm2015_ngxs-store-operators_js").then(() => (() => (__webpack_require__(/*! ./node_modules/@ngxs/store/fesm2015/ngxs-store-operators.js */ 49284))))));
			register("@ngxs/store", "3.8.1-dev.master-43ab43c", () => (__webpack_require__.e("node_modules_ngxs_store_fesm2015_ngxs-store_js-_471d1").then(() => (() => (__webpack_require__(/*! ./node_modules/@ngxs/store/fesm2015/ngxs-store.js */ 13112))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};